import { connect } from 'react-redux'
import * as action from '../../state/list/action'
import * as selector from '../../state/list/selector'
import ShipmentList from './../list/ShipmentList'
import { selectSalesOrder, selectShipmentList } from '../../../sales-order/state/detail/selector'
import { addShipment } from '../../../sales-order/state/detail/action'

const mapStateToProps = (state, props) => {
    return {
        fetching: selector.selectIsFetching(state),
        shipmentList: selectShipmentList(state),
        salesOrder: selectSalesOrder(state),
        shipmentDetailOpen: selector.selectShipmentDetailOpen(state),
    }
}

const mapDispatchToProps = {
    createShipment: action.createShipment,
    addShipment: addShipment,
    toggleShipmentTracking: action.toggleShipmentTracking,
}


export default connect(mapStateToProps, mapDispatchToProps)(ShipmentList)



// WEBPACK FOOTER //
// ./src/modules/logistic/component/task-widget/ShipmentListWidgetContainer.js